module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_vtrusguard_m_jp.b9bd7b700bd011d267ecb43736a3707b.png";